import { Conversation } from 'business';
import { useBatchedQuery } from 'bridge';

export default function useConversations(userId?: string) : [Conversation[], () => void]  {
    const [conversations, onLoadMoreConversations] = useBatchedQuery({ userId: userId, queryType: 'conversationsMine'});
    return [conversations, onLoadMoreConversations];
}
